// Form validation for New credential form
import { plaintextValidator } from '../fields';

const config = { mandatory: true, customError: `^ Required` };

export default {
  clientId: plaintextValidator(config),
  siteId: plaintextValidator(config),
  assetId: plaintextValidator(config)
};
